import { getEnv } from '@config';

const { country, publicPath } = getEnv();

const FLAG_IMG = {
  cl: 'FpayChileLogo.svg',
  pe: 'FpayPeruLogo.svg',
  co: 'FpayColombiaLogo.svg',
};

export const LOGO_IMG = `${publicPath}/assets/images/${FLAG_IMG[country.toLowerCase()]}`;
